import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function integerOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }
    const stringValue = String(value).trim();

    return /^-?\d+$/.test(stringValue) ? null : { integerOnly: true };
  };
}
